<template>
  <div>
    <el-container style="height: 100vh;">
      <el-aside width="200px" style="background-color:#000000">
        <Asides></Asides>
      </el-aside>
      <el-container>
        <el-header  style="background-color: #F5F6FB" class="change">
          <Header></Header>
        </el-header>
        <el-main style="background-color: #F5F6FB" class="change">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Asides from "@/components/aside";
import Header from "@/components/header";
export default {
  components: {
    Asides,Header
  },
}
</script>
<style scoped>
.change{
  height: 72px!important;
}
</style>
